import { useCallback } from 'react';
import { useEffect, useState } from 'react';
import apiLanguageMethodService from '../api/apiLanguages';
import { getStaticText } from '../../../lables/lablesService';

const useTableService = () => {
    //State for per page
    const [perPage] = useState(8);
    //State for all page data table
    const [allPage, setAllPage] = useState([]);
    //State for loading data
    const [loading, setLoading] = useState(true);
    //State for table data
    const [dataTable, setDataTable] = useState([]);
    //State for response error
    const [respError, setRespError] = useState("");
    //State current page
    const [currentPage, setCurrentPage] = useState(1);
    //State for the duplicate value error message
    const [successfulMsg, setSuccessfulMsg] = useState("");
    //State for the duplicate value error message
    const [unsuccessfulMsg, setUnsuccessfulMsg] = useState("");
    //State for the duplicate value error message
    const [successfulUpdateMsg, setSuccessUpdatefulMsg] = useState("");
    //State for the duplicate value error message
    const [unsuccessfulUpdateMsg, setUnsuccessfulUpdateMsg] = useState("");
    //State for sorting rows dy id
    const [sortId, setSortId] = useState({
        "id": "DESC" ? "DESC" : "ASC",
    });
    //State for sorting rows dy name
    const [sortName, setSortName] = useState({
        "name": "ASC" ? "ASC" : "DESC",
    })
    //State for sorting rows dy iso
    const [sortIso, setSorIso] = useState({
        "iso": "ASC" ? "ASC" : "DESC",
    })
    //State for sorting rows dy flag
    const [sortFlag, setSorFlag] = useState({
        "flag": "ASC" ? "ASC" : "DESC",
    })
    //State for sorting rows dy is_default
    const [sortIs_Default, setSorIs_Default] = useState({
        "is_default": "ASC" ? "ASC" : "DESC",
    })

    /**
      * Method sort table rows 
      * 
      * @params key string
      */
    const handleSortRows = key => {

        if (key === 'id')
            setSortId(prev => ({
                ...prev,
                id: prev.id === 'DESC' ? 'ASC' : 'DESC'
            }))

        if (key === 'name')
            setSortName(prev => ({
                ...prev,
                name: prev.name === 'DESC' ? 'ASC' : 'DESC'
            }))

        if (key === 'iso')
            setSorIso(prev => ({
                ...prev,
                iso: prev.iso === 'DESC' ? 'ASC' : 'DESC'
            }))

        if (key === 'flag')
            setSorFlag(prev => ({
                ...prev,
                flag: prev.flag === 'DESC' ? 'ASC' : 'DESC'
            }))

        if (key === 'is_default')
            setSorIs_Default(prev => ({
                ...prev,
                is_default: prev.is_default === 'DESC' ? 'ASC' : 'DESC'
            }))
    }

    /**
     * Method add row in table
     * 
     * @params obj
     * @returns new obj
     */
    const addRowsValue = async ({ iso, flag, name, active, is_default }) => {
        const newRows = {
            iso,
            flag,
            name,
            active: active ? 1 : 0,
            is_default: is_default ? 1 : 0
        }

        try {
            const response = await apiLanguageMethodService.addLanguageList(newRows);

            // Condition response error
            if (response.error) {
                setUnsuccessfulMsg(response.errors[0])
                return
            }
            
            // Condition response success
            if (!response.error) {
                setSuccessfulMsg(getStaticText('lng_add_success'))
            }

            return response;
        } catch (error) {
            console.log('eroor', error);
        }
    }

    /**
     * Method update row in table
     * 
     * @params obj
     * @returns update object
     */
    const updateRowValue = async ({ id, iso, flag, name, active, is_default }) => {
        const updateRow = {
            id,
            iso,
            flag,
            name,
            active: active ? 1 : 0,
            is_default: is_default ? 1 : 0
        }
        try {
            const response = await apiLanguageMethodService.updateLanguageList(updateRow);

            // Condition response error
            if (response.error) {
                setUnsuccessfulUpdateMsg(response.errors[0])
                return
            }

            // Condition response success
            if (!response.error) {
                setSuccessUpdatefulMsg(getStaticText('lng_update_success'))
            }

            return response;

        } catch (error) {
            console.log('eroor', error);
        }
    }

    /**
     * Method get table rows data 
     */
    const fetchPageList = useCallback(async () => {

        const params = {
            page: currentPage,
            per_page: perPage,
            order: sortId,
        }

        try {
            const response = await apiLanguageMethodService.getLanguageList(params);

            if (response.error) {
                setRespError(response.errors[0])
                return
            }
            if (response) setLoading(false);

            setDataTable(response.rows);
            setAllPage(response.all_pages);
        } catch (error) {
            console.log('error', error);
        }
    }, [currentPage, perPage, sortId])

    //Fetch table data list
    useEffect(() => {

        fetchPageList();
    }, [fetchPageList])

    /**
     * Method sort rows by name 
     */
    const fetchPageListSortName = async () => {

        const params = {
            page: currentPage,
            per_page: perPage,
            order: sortName,
        }

        try {
            const response = await apiLanguageMethodService.getLanguageList(params);

            if (response.error) {
                setRespError(response.errors[0])
                return
            }

            if (response) setLoading(false);

            setDataTable(response.rows);
            setAllPage(response.all_pages);
        } catch (error) {
            console.log('error', error);
        }
    }

    /**
     * Method sort rows by iso 
     */
    const fetchPageListSortIso = async () => {

        const params = {
            page: currentPage,
            per_page: perPage,
            order: sortIso,
        }

        try {
            const response = await apiLanguageMethodService.getLanguageList(params);

            if (response.error) {
                setRespError(response.errors[0])
                return
            }

            if (response) setLoading(false);

            setDataTable(response.rows);
            setAllPage(response.all_pages);
        } catch (error) {
            console.log('error', error);
        }
    }

    /**
     * Method sort rows by flag
     */
    const fetchPageListSortFlag = async () => {

        const params = {
            page: currentPage,
            per_page: perPage,
            order: sortFlag,
        }

        try {
            const response = await apiLanguageMethodService.getLanguageList(params);

            if (response.error) {
                setRespError(response.errors[0])
                return
            }

            if (response) setLoading(false);

            setDataTable(response.rows);
            setAllPage(response.all_pages);
        } catch (error) {
            console.log('error', error);
        }
    }

    /**
     * Method sort rows by is_default
     */
    const fetchPageListSortIsDefault = async () => {

        const params = {
            page: currentPage,
            per_page: perPage,
            order: sortIs_Default,
        }

        try {
            const response = await apiLanguageMethodService.getLanguageList(params);

            if (response.error) {
                setRespError(response.errors[0])
                return
            }

            if (response) setLoading(false);

            setDataTable(response.rows);
            setAllPage(response.all_pages);
        } catch (error) {
            console.log('error', error);
        }
    }

    //Pagination logic
    const indexOfLast = currentPage * perPage;
    const indexOfFirst = indexOfLast - perPage;
    const currentData = dataTable.slice(indexOfFirst, indexOfLast);

    const allTableData = {
        allPage,
        loading,
        respError,
        dataTable,
        setAllPage,
        currentData,
        currentPage,
        setDataTable,
        addRowsValue,
        fetchPageList,
        successfulMsg,
        updateRowValue,
        handleSortRows,
        setCurrentPage,
        unsuccessfulMsg,
        setSuccessfulMsg,
        setUnsuccessfulMsg,
        successfulUpdateMsg,
        fetchPageListSortIso,
        fetchPageListSortName,
        fetchPageListSortFlag,
        unsuccessfulUpdateMsg,
        setSuccessUpdatefulMsg,
        setUnsuccessfulUpdateMsg,
        fetchPageListSortIsDefault,
    }

    return allTableData;
}

export default useTableService;